import { Container, Row } from "reactstrap";
import BarChart from "./BarChart";
import DoughnutChart from "./DoughnutChart";
import LineChart from "./LineChart";
import LineGraph from "./LineGraph";
import PolarChart from "./PolarChart";
import RadarGraph from "./RadarGraph";
import { Breadcrumbs } from "../../../AbstractElements";
import { ChartJSChart, Charts } from "../../../Constants/Constants";

const ChartJsChartContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={ChartJSChart} parent={Charts} />
      <Container fluid>
        <Row>
          <BarChart />
          <LineGraph />
          <RadarGraph />
          <LineChart />
          <DoughnutChart />
          <PolarChart />
        </Row>
      </Container>
    </>
  );
};
export default ChartJsChartContainer;
